import React from 'react'
import PropTypes from 'prop-types'

const propTypes = {
  message: PropTypes.string.isRequired,
}

function SrStatusMessage({ message }) {
  return (
    <span
      role="status"
      className="visually-hidden"
      aria-live="polite"
      aria-atomic
    >
      {message}
    </span>
  )
}

SrStatusMessage.propTypes = propTypes

export default SrStatusMessage
